export default __webpack_public_path__ + "static/Tranquilizer_Dart-9d62a9547370e295c2bfcf1b3b31eb17.png";